<template>
	<div class="bodywrap">
		<!--<div class="bannerwrap clearfix">
	        <ul class="clearfix">         	
	        	<li v-for="(item,index) in bannerList">
	               <img class="fl" :src="item.imgPath" alt="" />
	        	</li>
	        </ul>
		</div>-->

		<div class="bannerwrap clearfix">
			<mt-swipe :auto="4000">
				<mt-swipe-item v-for="(item,index) in bannerList">
					<img class="fl" :src="commmonWebConfig.picHost+'/groupbuy'+item.imgPath" alt="" style=" width: 100%;height: auto;" />
				</mt-swipe-item>
			</mt-swipe>
		</div>
		<div class="groupwrap">
			<div class="groupRoom">
				<em class="icon01"></em>
				<em class="icon02"></em>
				<div class="groupcar">
					<div class="borderLine">
						<div class="groupdetail">
							<div class="group-tit" v-text="basic.groupName"></div>
							<div class="groupSizewrap">
								<div class="group-text">
									<div class="sizeRed" v-text="basic.title">
										<!--<em class="yellow">限244人，先到先得</em>-->
									</div>
									<div class="graysize" v-if="basic.beginTime && basic.endTime">活动时间：
										<span>
										{{basic.beginTime?$moment(basic.beginTime).format("MM-DD HH:mm"):''}}
									</span>-
										<span>
										{{basic.endTime?$moment(basic.endTime).format("MM-DD HH:mm"):''}}
									</span>
									</div>
									<div class="graysize" v-if="basic.address">
										活动地址:
										<span>
											{{basic.address?basic.address:''}}
										</span>
									</div>
									<div class="graysize" v-if="basic.dealerName">
										活动经销商:
										<span>
											{{basic.dealerName?basic.dealerName:''}}
										</span>
									</div>
									<div class="graysize" v-if="basic.brandName">
										参团品牌:
										<span>
											{{basic.brandName ?basic.brandName:''}}
										</span>
									</div>
									<div class="graysize" v-if="basic.styleName">
										参团车型:
										<span>
											{{basic.styleName ? basic.styleName:''}}
										</span>
									</div>
									<div class="graysize" v-if="basic.modelName">
										参团车款:
										<span>
											{{basic.modelName ? basic.modelName:''}}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--优惠-->
			<div class="preferential">
				<div class="preferential-tit">{{dispointText}}<em></em></div>
				<div class="groupRoom">
					<em class="icon05"></em>
					<div class="groupcar" style="margin-top:0;">
						<div class="groupdetail">
							<ul class="preferentialUl clearfix">
								<li class="clearfix" v-for="(item,index) in youHuiList" :class="index%2==0 ? '' : 'whiteColor' ">
									<span class="leftspan">{{item.personLimitCounts}}人成团</span>
									<span class="rightspan">{{item.instruction}}<em class="redsize"></em></span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<!--当前团购用户-->  
			<div class="curperson" v-show="personcur">	
				<div class="person-tit">{{userText}}<em v-if="basic.joinNum">{{basic.joinNum}}</em><em class="pericon"></em></div>
				<div class="groupRoom clearfix">
					<em class="icon03"></em>
					<em class="icon04"></em>
					<div class="groupcar clearfix">
						<div class="groupdetail clearfix">
							<!--已参加-->
							<div class="readyattend">
								<ul class="perList clearfix">
									<li v-for="(item,index) in curperlist">
										<img :src="commmonWebConfig.webCommonUtils+'/img/mapply/groupbuy/pericon.png'" alt="" />
										<p>团友{{item}}</p>
									</li>
								</ul>
								<div class="lookMore" v-if="toLearnList.length > 8" @click="word">{{words}} <em :class="showAll ? 'arror-t' : 'arror-b'"></em></div>
							</div>
							<!--尚无-->
							<div class="notYet" v-show="netYet">
								<div class="noneCar">
									<div class="caricon"></div>
									<p>{{userMemoText}}</p>
									<button class="notYet-sub" @click="showMask" id="notYet-sub" :disabled="(applyType==2 || applyType ==4 ||applyType ==5 || applyType ==6)">{{btnText[applyType-1]}}</button>
								</div>
								<!--<div class="invitewrap" v-show="remind">
							 	  	 <button class="notYet-sub">免费预约</button>
							 	  	 <p class="invite">**人已预约</p>
							 	  </div>-->
							</div>

						</div>
					</div>
				</div>
			</div>
			<!--新增图片-->
			<div class="addpop" style="margin: -.133333rem 0 0 -.266666rem;">
				<!-- <img :src="commmonWebConfig.webCommonUtils+'/img/mapply/groupbuy/addpop.jpg'" alt="" /> -->
				<img v-if="publicityImg!=null && publicityImg.length>0" :src="commmonWebConfig.picHost+'/groupbuy'+publicityImg[0].imgPath" alt="" />
			</div>
			<!--活动-->
			<div class="activity">
				<div class="preferential-tit">{{noticeText}}<em></em></div>
				<div class="groupRoom">
					<em class="icon06"></em>
					<em class="icon07"></em>
					<div class="groupcar" style="margin-top:0;">
						<div class="groupdetail">
							<ul class="activity-text">
								<li class="toBtn" v-html="basic.introduction">
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<button :class="btndisabled ? 'grayBtn' : 'submitBtn'" :disabled="(applyType==2 || applyType ==4 ||applyType ==5 || applyType ==6)" @click="showMask" v-show="showTest">{{btnText[applyType-1]}}</button>

			<!--弹窗-->
			<div class="pop-mask" v-show="isShowmask"></div>
			<div class="showmask" v-show="isShowmask">
				<!--<div class="mask-tit">
					<em class="lin01"></em> 登录享购车优惠
					<em class="lin02"></em>
				</div>-->
				<div class="inputwrap">
					<input type="tel" v-model="inputVal" placeholder="请输入手机号" name="" id="" value="" />
				</div>
				<!--<div class="inputwrap">
					<input type="tel" v-model="validatecode" class="codeInput" placeholder="请输入验证码" name="" id="" value="" />
					<button :class="disabled ? 'getCode' : 'getCode'" @click="timeEnd" :disabled="disabled">{{codemsg}}</button>
				</div>-->
				<button class="maskSub" @click="submitMsg" :disabled="(applyType==2 || applyType ==4 ||applyType ==5|| applyType ==6)">{{btnText[applyType-1]}}</button>

				<div class="appointment" v-if="applyType==1 && (basic.joinNum !=0 || basic.baseNum !=0)">{{basic.joinNum + basic.baseNum}}人已预约</div>
				<div class="closemask" @click="closemask"></div>
			</div>
			<div class="popUp" v-show="isLading"></div>
		</div>
	</div>

</template>
<style type="text/css" lang="less" scoped>

</style>
<script type="text/javascript">
	import { Toast } from 'mint-ui';
	export default {
		name: 'index',
		data() {
			return {
				noneCurpeson: false,
				showTest: false,
				isLading: false, //蒙层
				personcur: false,//团购列表
				isShowmask: false,
				netYet: false,
				//noneCarIcon: false,
				//remind:false,
				showAll: false,
				inputVal: '',
				validatecode: '',
				count: 60,
				words: '查看更多',
				disabled: false,
				btndisabled: false,
				grayBtn: false,
				toLearnList: [],
				curperlist: [],
				youHuiList: [],
				bannerList: [],
				basic: {},
				isbtnText: '免费参团',
				ismaskText: '',
				appointmentflag: false,
				curtime: '',
				applyType: 6,
				applyTypeDefault: 1,
				backbeginTime: '',
				backendTime: '',
				btnText: [
					"免费预约",
					"已预约",
					"免费参团",
					"已参团",
					"已结束",
					"加载中"
				],
				temp: null,
				reload: null,
				notice: '',
				userText: '',
				dispointText: '',
				userMemoText: '',
				noticeText: '',
				_applyId: '',
				bannerType: [1,2],		//1=>banner图	 2=>宣传图
				publicityImg: []
			}
		},
		beforeCreate: function() {
			document.title = "团车团购";
			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/groupbuy/index.css"
			});
		},
		mounted: function() {
			var self = this;
			//确保重要依赖的js加载完成
			getCommonJsIns.initJSNEW(this.webReady);
			/***统计添加**/
			!function(e, t, n, g, i) {
			    e[i] = e[i] || function() { 
			    	(e[i].q = e[i].q || []).push(arguments)
			    };
			    var n = t.createElement("script");
			    var tag = t.getElementsByTagName("script")[0];
			    n.async = 1;
			    n.src = ('https:' == document.location.protocol ? 'https://': 'http://') + g;
			    tag.parentNode.insertBefore(n, tag);
			} (window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
			gio('init', '8004d11f5708cccc', {});
			//custom page code begin here
			//custom page code end here
			gio('send');
			gio('enableHT', 'true');
			/***统计添加**/
		},
		methods: {
			webReady: function() {
				var self = this;
				self.information();
				self.scrollbanner();
				self.publicitybanner();
				self.reward();
				self.offeredUsers();
			},
			initTime: function(){
				var self = this;
				self.curtime = Date.parse(new Date()); //当前时间
				if(self.backbeginTime != "" || self.backendTime !="") {
					if(localStorage.getItem('userphone_' + self.$route.query.groupId)) {
						if(self.curtime < self.backbeginTime) { //已预约
							self.applyType = 2;
						}else if(self.curtime > self.backbeginTime && self.curtime < self.backendTime) { //已参团						
							if(self.applyTypeDefault == 1 || self.applyTypeDefault == 2) { //预约 && 已发送短信
								self.applyType = 3; //已预约
							} else if(self.applyTypeDefault == 3) {
								self.applyType = 4; //已参团
							}
						} else if(self.curtime > self.backendTime) { //结束
							self.applyType = 5;
						}
					} else {
						if(self.curtime < self.backbeginTime) { //免费预约
							self.applyType = 1;
						} else if(self.curtime > self.backbeginTime && self.curtime < self.backendTime) { //免费参团
							self.applyType = 3;
						} else if(self.curtime > self.backendTime) { //结束
							self.applyType = 5;
						}
					}
					if(self.applyType == 5) {
						clearInterval(self.temp);
					}
					
					if (self.applyType == 1 || self.applyType == 2) {
						self.personcur=false;
					}
					if (self.netYet) {
						if (self.applyType == 5) {
							self.userMemoText = '团购已结束';
						} else {
							self.userMemoText = '尚无团购,快来加入吧';
						}
					}
					
				}
			},
			showList: function() {
				var self = this;
				self.curperlist = [];
				if(!self.showAll) {
					for(var i = 0; i < self.toLearnList.length; i++) {
						if(i < 8) {
							self.curperlist.push(self.toLearnList[i]);
						}
					}
				} else {
					self.curperlist = self.toLearnList;
				}
			},
			word: function() {
				var self = this;
				if(!self.showAll) { //对文字处理
					self.words = '收起'
				} else {
					self.words = '查看更多';
				}
				self.showAll = !self.showAll;
				self.showList();
			},
			closemask: function() {
				var self = this;
				self.isShowmask = false;
			},
			showMask: function(){//点击底部弹窗
				var self = this;
				  if(self.curtime < self.backbeginTime) { //免费预约
				  
					if(self.$route.query.applyId){//新增获取url里面 applyId 调用提交接口
						//存储用户 报名id参团
						localStorage.setItem('userphone_' + self.$route.query.groupId, self.$route.query.applyId);
						localStorage.setItem('applyid_' + self.$route.query.groupId, self.$route.query.applyId);
						var param = {
							"groupId": self.$route.query.groupId,
							"applyType": self.applyType,
							"applyId":self.$route.query.applyId
						};
						console.log(self.$route.query.applyId);
						self.ajaxSubmit.ajax({
						contentType: 'application/json;charset=UTF-8',
							url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyGroupBuy,
							type: "post",
							data: JSON.stringify(param),
							async: false,
							dataType: 'json',
							success:function(data){
								self.isLading = false;
								self.isShowmask = false;
								if(data.responseHeader.status = 200){
									if(localStorage.getItem('userphone_' + self.$route.query.groupId, self.$route.query.applyId)){
											var isReload = false;
											if(self.curtime < self.backbeginTime) { //已预约				
												if(data.response.result == 1) {
													Toast('没有拼团活动');
												} else if(data.response.result == 2) {
													Toast('预约成功，活动开始时会给您发短信提醒');
													isReload = true;
												} else if(data.response.result == 3) {
													Toast('您已预约过');
													isReload = true;
												} else if(data.response.result == 4) {
													Toast('预约时间未开始');
												}
		
											} else if(self.curtime > self.backbeginTime && self.curtime < self.backendTime) { //已参团
												if(data.response.result == 1) {
													Toast('没有拼团活动');
												} else if(data.response.result == 2) {
													Toast('参团成功');
													isReload = true;
												} else if(data.response.result == 3) {
													Toast('您已参团过');
													isReload = true;
												} else if(data.response.result == 4) {
													Toast('参团时间未开始');
												}
											}
		
											if(isReload){
												setTimeout(function() {
													window.location.reload();
												}, 3000);
		
											}else{
												localStorage.removeItem('userphone_' + self.$route.query.groupId);
												localStorage.removeItem('applyid_' + self.$route.query.groupId);
												localStorage.removeItem('phone_' + self.$route.query.groupId);
											}
									}
								}else{
									console.log("请求失败");
								}
							},error:function(){
								console.log('error');
							}
						});
					}else{
						self.isShowmask = true;
						self.inputVal="";
			   		}
			   	}else{
					if(localStorage.getItem('applyid_' + self.$route.query.groupId)||localStorage.getItem('phone_' + self.$route.query.groupId)){
						self.submitMsg();
					}else{
						self.isShowmask = true;
						self.inputVal="";
					}
				}
			},
			information: function() { //基本信息
				var self = this;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.groupbasic + "/" + self.$route.query.groupId + "/",
					type: 'get',
					success: function(data) {
						self.noticeText = '活动须知';
						if(data.responseHeader.status == 200) {
							self.basic = data.response.result.basic;
							self.backbeginTime = data.response.result.basic.beginTime;
							self.backendTime = data.response.result.basic.endTime;
							self.showList();
							//self.initTime(self.backbeginTime, self.backendTime);
							//clearInterval(self.temp);
							// 团购类型 
							if(data.response.result.basic.groupType == 1) { //品牌团购
								self.basic.brandName = data.response.result.basic.brandName;
								self.basic.styleName = "";
								self.basic.modelName = "";
							} else if(data.response.result.basic.groupType == 2) { //车型团购
								self.basic.brandName = data.response.result.basic.brandName;
								self.basic.styleName = data.response.result.basic.styleName;
								self.basic.modelName = "";
							} else if(data.response.result.basic.groupType == 3) { //车款团购
								self.basic.brandName = data.response.result.basic.brandName;
								self.basic.styleName = data.response.result.basic.styleName;
								self.basic.modelName = data.response.result.basic.modelName;
							}
							//self.temp = setInterval(function() {
							//	self.initTime();
							//}, 10000);
							self.showTest = true;
						} else {
							console.log('请求失败');
						}
					},
					error: function() {
						console.log('error');
						self.noticeText = '活动须知';
					}
				});
			},
			scrollbanner: function() {
				var self = this;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.groupbanners + "/" + self.$route.query.groupId + "/"+self.bannerType[0],
					type: 'get',
					success: function(data) {
						if(data.responseHeader.status == 200) {
							self.bannerList = data.response.result.bannerList;
						} else {
							console.log('请求失败');
						}
					},
					error: function() {
						console.log('error');
					}

				});
			},
			publicitybanner: function() {
				var self = this;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.groupbanners + "/" + self.$route.query.groupId + "/"+self.bannerType[1],
					type: 'get',
					success: function(data) {
						// console.log(data);
						if(data.responseHeader.status == 200) {
							self.publicityImg = data.response.result.bannerList;
						} else {
							console.log('请求失败');
						}
					},
					error: function() {
						console.log('error');
					}

				});
			},
			reward: function() { //奖励
				var self = this;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.grouprulers + "/" + self.$route.query.groupId + "/",
					type: 'get',
					success: function(data) {
						self.dispointText = '成团优惠';
						if(data.responseHeader.status == 200) {
							self.youHuiList = data.response.result.tacticsList;
						} else {
							console.log('请求失败');
						}
					},
					error: function() {
						console.log('error');
						self.dispointText = '';
					}

				});
			},
			offeredUsers: function() { //拼团参团用户
				var self = this;
				self.inputVal = localStorage.getItem('userphone_' + self.$route.query.groupId);
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.groupusers + "/" + self.$route.query.groupId + "/",
					data: {
						"phone": self.inputVal
					},
					type: 'get',
					success: function(data) {
						self.userText = '当前团购用户  ';
						if(data.responseHeader.status == 200) {
							if(data.response.result.userInfo) {
								self.applyTypeDefault = data.response.result.userInfo.applyType;
							}						
							if(data.response.result.users==''||data.response.result.users==null||data.response.result.users==undefined){
								  if(data.response.result.userInfo == null || data.response.result.userInfo=="" || data.response.result.userInfo ==undefined){
								  	 self.netYet=true;
									 self.personcur = true;
								  }else{
								   self.personcur = false;//预约不显示	
								  }
							}else{
								self.personcur = true;//预约不显示
							}
							if(data.response.result.users) {
								self.toLearnList = data.response.result.users;
								if(self.toLearnList.length > 8) {
									self.showAll = false;
									self.words = '查看更多';
								}
								self.showList();
							}
							if(self.curtime > self.backendTime) { //已结束
								if(!localStorage.getItem('userphone_' + self.$route.query.groupId)){
									self.personcur = false;
								}else{
									self.personcur = true;
								}
							}
							self.initTime();
							clearInterval(self.temp);
							self.temp = setInterval(function(){
								self.initTime();
							}, 10000);
						} else {
							console.log('请求失败');
						}
					},
					error: function() {
						console.log('error');
						self.userText = '';
					}
				});
			},
			submitMsg: function() { //提交接口
				var self = this;
				var isPhone = localStorage.getItem('phone_' + self.$route.query.groupId);
				var isApplyId = localStorage.getItem('applyid_' + self.$route.query.groupId);
				if(isPhone){
					self.inputVal = isPhone;
				};
				if(isApplyId){
					self._applyId = isApplyId;
				};
				if(!self._applyId && !self.inputVal) {
					Toast('请输入手机号');
				} else if(!self.inputVal&&!webCommonUtil.commonFun.isPhone(self.inputVal)) {
					Toast('请输入正确的手机号');
				} else {
					self.isLading = true;
					self.inputVal = self.inputVal;
					//存储用户手机号
					localStorage.setItem('userphone_' + self.$route.query.groupId, self.inputVal);
					localStorage.setItem('phone_' + self.$route.query.groupId, self.inputVal);
					// console.log(self.inputVal);
					var param = {
						"phone": self.inputVal,
						"groupId": self.$route.query.groupId,
						"applyType": self.applyType,
						"applyId": self._applyId,
						"c": self.$route.query.c
					};
					self.ajaxSubmit.ajax({
						contentType: 'application/json;charset=UTF-8',
						url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyGroupBuy,
						type: "post",
						data: JSON.stringify(param),
						async: false,
						dataType: 'json',
						success: function(data) {
							console.log(data);
							self.isLading = false;
							self.isShowmask = false;
							if(data.responseHeader.status = 200) {
								if(localStorage.getItem('userphone_' + self.$route.query.groupId)){
									var isReload = false;
									if(self.curtime < self.backbeginTime) { //已预约				
										if(data.response.result == 1) {
											Toast('没有拼团活动');
										} else if(data.response.result == 2) {
											Toast('预约成功，活动开始时会给您发短信提醒');
											isReload = true;
										} else if(data.response.result == 3) {
											Toast('您已预约过');
											isReload = true;
										} else if(data.response.result == 4) {
											Toast('预约时间未开始');
										}

									} else if(self.curtime > self.backbeginTime && self.curtime < self.backendTime) { //已参团
										if(data.response.result == 1) {
											Toast('没有拼团活动');
										} else if(data.response.result == 2) {
											Toast('参团成功');
											isReload = true;
										} else if(data.response.result == 3) {
											Toast('您已参团过');
											isReload = true;
										} else if(data.response.result == 4) {
											Toast('参团时间未开始');
										}
									}
									if(isReload){
										setTimeout(function() {
											window.location.reload();
										}, 3000);
									}else{
										localStorage.removeItem('userphone_' + self.$route.query.groupId);
										localStorage.removeItem('applyid_' + self.$route.query.groupId);
										localStorage.removeItem('phone_' + self.$route.query.groupId);
									}
								}

							} else {
								console.log('请求失败')
								self.isLading = false;
							}
						},
						error: function() {
							self.isLading = false;
						}
					});
				}
			}
		}

	}
</script>


// WEBPACK FOOTER //
// src/views/groupbuy/index.vue